import { useMarketplaceChain } from '@/hooks/use-marketplace-chain';
import { useENSResolver } from '@/hooks/useENSResolver';
import { routes } from '@/utils/routes';
import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { WalletLink } from '@sphere/ui';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  address: string;
} & FlexProps;

export const CreatorLink = ({ address, ...props }: Props) => {
  const { t } = useTranslation('collection');
  const { displayName } = useENSResolver(address);
  const marketplaceChain = useMarketplaceChain();

  return (
    <Flex gap="space.6" align="center" color="white" {...props}>
      <Text>{t('hero.creator.prefix')}</Text>
      {address && (
        <WalletLink
          href={routes.profile(address, marketplaceChain.routePrefix)}
          walletAddress={address}
          username={displayName}
          fontWeight="medium"
          lineHeight="sm"
        />
      )}
    </Flex>
  );
};
